export const getQueretaroData = () => ({
  name: "Querétaro",
  country: "Mexique",
  description: "Querétaro est une région viticole émergente du centre du Mexique, réputée pour ses vins effervescents et ses blancs frais grâce à son altitude élevée et son climat tempéré.",
  type: "region",
  mapAreas: [
    { region: "Querétaro", x: 40, y: 60, color: "#8a4a8a", size: 2 }
  ],
  statistics: {
    totalArea: "400 ha",
    production: "0.02 million hectolitres",
    appellations: "Aucune (région libre)",
    subregions: "Ezequiel Montes, Tequisquiapan",
    exportPercentage: "3%"
  },
  characteristics: {
    climate: "Climat tempéré, altitude élevée (1 800-2 000 m), nuits fraîches",
    soil: "Sols calcaires, argileux, bonne rétention d'eau",
    viticulture: "Viticulture moderne, orientation vers les vins effervescents"
  },
  wineStyles: {
    red: "Vins rouges légers et fruités (Tempranillo, Merlot, Malbec)",
    white: "Vins blancs frais et aromatiques (Sauvignon Blanc, Chardonnay)",
    sparkling: "Vins effervescents de méthode traditionnelle, spécialité régionale"
  },
  history: "La viticulture à Querétaro s'est développée dans les années 1970. La région est aujourd'hui reconnue pour ses bulles et ses blancs, attirant l'œnotourisme.",
  foodPairing: "Cuisine mexicaine moderne, fromages de chèvre, fruits de mer, plats épicés.",
  subregions: {
    "ezequiel-montes": {
      name: "Ezequiel Montes",
      description: "Centre de la production viticole, réputé pour ses vins effervescents et blancs frais.",
      characteristics: {
        climate: "Tempéré, altitude élevée",
        soil: "Sols calcaires et argileux",
        viticulture: "Vignobles modernes, orientation effervescents"
      },
      grapeVarieties: {
        white: ["Sauvignon Blanc", "Chardonnay"],
        red: ["Tempranillo", "Merlot"]
      },
      wineStyles: {
        "effervescent": "Bulles fines et fraîches",
        "blanc": "Blancs aromatiques et tendus"
      },
      foodPairing: "Fromages de chèvre, fruits de mer, plats épicés"
    },
    "tequisquiapan": {
      name: "Tequisquiapan",
      description: "Zone touristique et viticole, connue pour ses vins blancs et effervescents.",
      characteristics: {
        climate: "Tempéré, altitude élevée",
        soil: "Sols calcaires et argileux",
        viticulture: "Vignobles modernes, tourisme viticole"
      },
      grapeVarieties: {
        white: ["Chardonnay", "Sauvignon Blanc"],
        red: ["Malbec", "Merlot"]
      },
      wineStyles: {
        "effervescent": "Vins effervescents frais et fruités",
        "blanc": "Blancs aromatiques et vifs"
      },
      foodPairing: "Cuisine mexicaine moderne, fromages, fruits de mer"
    }
  }
}); 